import React from "react"

import { H4, Trunc } from "../el/appnotetypography"
import { PillLink } from "../el/button"
const RelatedAppsBlockNew = props => {
  // AppLink Component
  const AppLink = ({ title, description, url }) => {
    const truncatedDescription = Trunc(description, 120)
    return (
      <div className="w-full py-0.5 lg:w-3/4 xl:w-3/5">
        <h3
          className="text-xs font-semibold text-slate-800"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h3>
        <p
          className="text-xs font-light text-slate-600"
          dangerouslySetInnerHTML={{ __html: truncatedDescription }}
        ></p>
        <PillLink color="blue" to={url}>
          See Application Note
        </PillLink>
      </div>
    )
  }

  return (
    <div className="mt-8">
      <H4 className="border-b border-slate-300">Related Application Notes</H4>
      <div className="space-y-3 xl:space-y-6">
        {props.relatedApps.edges.map(app => {
          return (
            <AppLink
              key={app.node.id}
              url={`../${app.node.url}`}
              title={app.node.title}
              description={app.node.description}
            />
          )
        })}
      </div>
    </div>
  )
}

export default RelatedAppsBlockNew
